import React from "react";

import Card from "../../../../components/Card";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import Button from "../../../../components/Button";
import Table from "../../../../components/Table";
import { Link } from "react-router-dom";
import {
  getGenderLabel,
  statusReservation,
} from "../../../../../utils/constants";
import PillItem from "../../../../components/PillItem";

export default function ListPharmacyComponents({
  handleChangeFilter = () => undefined,
  handleClearFilter = () => undefined,
  handleClickFilter = () => undefined,
  handlePagination = () => undefined,
  handleChangeSizePerPage = () => undefined,
  isLoading = false,
  filterPharmacy = {},
  dataPharmacy = [],
  activePage = 0,
  totalPage = 0,
  totalEntries = 0,
  sizePerPage = 10,
}) {
  const localize = useLocalization();

  const columns = [
    {
      label: localize.getText("noRm"),
    },
    {
      label: localize.getText("doctor"),
    },
    {
      label: localize.getText("patient"),
    },
    {
      label: localize.getText("status"),
    },
    {
      label: localize.getText("requestedOn"),
    },
    {
      label: localize.getText("timeVisit"),
    },
    {
      label: localize.getText("gender"),
    },
    {
      label: localize.getText("action"),
    },
  ];

  return (
    <Card>
      <Table
        columns={columns}
        loading={isLoading}
        activePage={activePage}
        totalPage={totalPage}
        totalShow={dataPharmacy?.length || 0}
        totalEntries={totalEntries}
        sizePerPage={sizePerPage}
        handlePagination={handlePagination}
        handleSizePerPage={handleChangeSizePerPage}
      >
        {dataPharmacy.map((item, index) => {
          return (
            <tr key={index}>
              <td>{item?.no_sequence}</td>
              <td>{item?.doctorName || "Dr. Unknown"}</td>
              <td>{item?.patient_name}</td>
              <td>
                {statusReservation
                  .filter((status) => status.value === item.status)
                  .map((item) => (
                    <PillItem
                      text={item.label}
                      key={index}
                      bgColor={item.color || "#6c757d"}
                    />
                  ))}
              </td>
              <td>{item?.time_request}</td>
              <td>
                <div className="d-flex flex-column">
                  <span style={{ fontWeight: "500" }}>{item?.visit_date}</span>
                  <span style={{ color: "#6c757d" }}>{item?.visit_time}</span>
                </div>
              </td>
              <td>{getGenderLabel(item.gender)}</td>
              <td>
                <Link
                  to={{
                    pathname: "/pharmacy/detail-pharmacy",
                    search: `?id=${item.id}&visit_id=${item.visit_id}`,
                  }}
                >
                  <Button tooltip="Tambahkan Obat" variant="success">
                    <i className="fas fa-pills"></i>
                  </Button>
                </Link>
              </td>
            </tr>
          );
        })}
      </Table>
    </Card>
  );
}
